
import styles from "../../ProductItem.module.css"


export const PayementFailure = ()=>{
    

    return <div>
    <div className="mt-5" style={{fontWeight:"bold",color:"#2c6b10",fontSize:32}}>Notikusi kļūda !</div>
    <div className="mt-2" style={{fontWeight:"400",color:"#2c6b10",fontSize:22}}>Vēlāk mēģiniet velreiz</div>
      </div>
};

